import { WidgetSkeleton } from '@src/components/Loading/WidgetSkeleton';
import { useGetBannerQuery } from '@src/services/promotion/promotionApiSlice';

export function Banner() {
  const { data, isLoading } = useGetBannerQuery({});

  if (isLoading) return <WidgetSkeleton className='h-full' />;

  return (
    <div className='h-full w-full'>
      <img
        src={data?.webDashboardBanner}
        className='w-full h-full object-contain sm:object-fill rounded-2xl'
        alt='Banner'
      />
    </div>
  );
}
